export { selectFactoryStyleReferences } from '#lib/list/factoryReferenceSelection';

export class FactorySourcePreparationError extends Error {
  constructor() {
    super('One or more Factory source images could not be uploaded.');
    this.name = 'FactorySourcePreparationError';
  }
}

export const prepareFactorySourceUrls = async <T>(
  sources: readonly T[],
  upload: (source: T, index: number) => Promise<string | null | undefined>,
  register: (url: string) => void = () => undefined,
): Promise<string[]> => {
  const results = await Promise.allSettled(
    sources.map((source, index) => upload(source, index)),
  );

  let failed = false;
  const urls = results.map((result) => {
    if (result.status === 'rejected') {
      failed = true;
      return '';
    }

    const url = typeof result.value === 'string' ? result.value.trim() : '';
    if (!url) {
      failed = true;
      return '';
    }

    try {
      register(url);
    } catch {
      // Asset registration improves later URL reuse but is not part of upload success.
    }
    return url;
  });

  if (failed) throw new FactorySourcePreparationError();
  return urls;
};
